/**
 * SHAP-ranked model drivers — the "What guides our analysis" block's
 * primary rendering when the BE curates `shap_drivers`. Each driver is a
 * humanized label + rounded share with a proportional bar, in the order
 * given (BE has already ranked + top-4'd + renormalized).
 */
import type React from "react"

import { Box, LinearProgress, Stack, Typography } from "@mui/material"

export const ShapDrivers: React.FC<{
  drivers: { label: string; share_pct: number }[]
}> = ({ drivers }) => (
  <Stack spacing={1}>
    {drivers.map((d) => (
      <Box key={d.label}>
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", mb: 0.25 }}
        >
          <Typography variant="body2">{d.label}</Typography>
          <Typography sx={{ fontWeight: "bold" }} variant="body2">
            {Math.round(d.share_pct)}%
          </Typography>
        </Stack>
        <LinearProgress
          aria-label={`${d.label} share of model influence`}
          aria-valuetext={`${Math.round(d.share_pct)}%`}
          sx={{ borderRadius: 1, height: 6 }}
          value={Math.min(100, d.share_pct)}
          variant="determinate"
        />
      </Box>
    ))}
  </Stack>
)
